<script>
export default {
  name: 'ImageSlider',
  props: {
    items: Array,
  },
  controller: {
    mouseDown: false,
    startX: 0,
    scrollLeft: 0,
    disableClick: false,
  },
  methods: {
    onMouseDown(e) {
      e.preventDefault();
      const slider = this.$refs.slider;

      this.$options.controller.mouseDown = true;

      slider.style.userSelect = 'none';
      slider.style.scrollSnapType = 'none';

      this.$options.controller.startX = e.pageX - slider.offsetLeft;
      this.$options.controller.scrollLeft = slider.scrollLeft;
    },
    onMouseMove(e) {
      e.preventDefault();
      e.stopPropagation();
      if(!this.$options.controller.mouseDown) return;
      this.$options.controller.disableClick = true;

      const slider = this.$refs.slider;

      const x = e.pageX - slider.offsetLeft;
      const scroll = x - this.$options.controller.startX;
      slider.scrollTo({ left: this.$options.controller.scrollLeft - scroll });
    },
    onStop() {
      if (!this.$options.controller.mouseDown) return;
      this.$options.controller.mouseDown = false;

      setTimeout(() => { this.$options.controller.disableClick = false; }, 1)

      const slider = this.$refs.slider;
      const gap = parseInt(window.getComputedStyle(slider).gap || slider.dataset.gap) || 0;
      const childWidth = (slider.scrollWidth - ((slider.children.length - 1) * gap)) / slider.children.length;
      const nth = Math.round(slider.scrollLeft / (childWidth + gap));
      const scrollToFix =  childWidth * nth + gap * nth;
      slider.scrollTo({ left: scrollToFix, behavior: 'smooth' });

      slider.style.userSelect = 'initial';
      slider.style.scrollSnapType = 'x mandatory';
    },
    onClick(idx) {
      if (this.$options.controller.disableClick) return;
      this.$emit('preview', idx);
    },
    scroll(direction) {
      const slider = this.$refs.slider;
      const firstChild = slider.children?.[0];

      if (!firstChild) return;
      const width = firstChild.clientWidth;

      const newScroll = slider.scrollLeft + width * direction;
      slider.scrollTo({ left: newScroll, behavior: 'smooth' });
    }
  },
}
</script>

<template lang="pug">
.b-image-slider
  button._prev(@click="scroll(-1)")
    Icon(name="arr-back" colored pointer)
  button._next(@click="scroll(1)")
    Icon(name="arr-back" colored pointer)
  ._items(ref="slider")
    img._item(
      v-for="(url, i) in items"
      :src="url"
      @dragstart="$event.preventDefault()"
      @mousemove="onMouseMove"
      @mousedown="onMouseDown"
      @mouseup="onStop"
      @mouseleave="onStop"
      @click="onClick(i)"
    )
</template>

<style scoped lang="scss">
.image-slider {
  --gap: 24px;
  --columns: 2;
  position: relative;

  &__prev,
  &__next {
    position: absolute;
    top: 50%;
    translate: 0 -50%;
    width: 33px;
    aspect-ratio: 1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F5F7F9;
    cursor: pointer;

    svg {
      color: #788CA1;
    }

    &:hover {
      background: #FFD059;

      svg {
        color: #fff;
      }
    }
  }

  &__prev {
    left: 13px;
  }

  &__next {
    right: 13px;

    svg {
      rotate: 180deg;
    }
  }

  &__items {
    display: flex;
    gap: var(--gap);
    overflow-x: auto;
    width: 100%;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;

    & > * {
      flex-shrink: 0;
      scroll-snap-align: start;
    }
  }

  &__item {
    width: calc((100% / var(--columns)) - var(--gap) + (var(--gap) / var(--columns)));
    aspect-ratio: 1.76;
    object-fit: cover;
    border-radius: 10px;
  }

  //@include media-breakpoint-down(xl) {
  //  --gap: 20px;
  //}
  //
  //@include media-breakpoint-down(lg) {
  //  --gap: 12px;
  //}
  //
  //@include media-breakpoint-down(md) {
  //  --gap: 8px;
  //}

  @media (max-width: 1200px) {
    --gap: 15px;

    &__item {
      //border-radius: 8px;
    }
  }
  @media (max-width: 767px) {
    //--gap: 13px;
    --columns: 1;

    &__items {
      //margin: 0 -15px;
      //width: calc(100% + 30px);
      //padding: 0 15px;
    }


    &__item {
      //height: auto;
      //width: 60vw;
      //aspect-ratio: 0.7;
      //scroll-snap-align: center;
    }
  }
}

</style>
